module.exports = __webpack_public_path__ + "static/media/cat9.09d2a667.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/images/cat9.jpeg
// module id = 41
// module chunks = 0